//import jQuery from 'jquery';
import './style.scss';

import './js/utils';
import './js/store';
import './js/vue-apollo-init';
import './js/vue-filter';
import './js/clicks';
import './js/scrolls';
import './js/styles';
import { Router } from './js/router';
import { Page_Content } from './js/components/vue-page-content';
import { Page_Title } from './js/components/vue-page-title';
import { Page_Content_Slider } from './js/components/vue-page-content-slider';
import { Article_Item_List } from './js/components/vue-article-item-list';
import { Header_Comps } from './js/components/vue-header-comps';
import { Menu_Comps } from './js/components/vue-menu-comps';

document.addEventListener("DOMContentLoaded", function() {
  const artisRouter = new Router();
  artisRouter.init();
  window.router = artisRouter.navigoRouter;
  //const pageTitle = new Page_Title();
  //pageTitle.init();
  const pageContent = new Page_Content();
  pageContent.init();
  const pageContentSlider = new Page_Content_Slider();
  pageContentSlider.init();
  const articleItemList = new Article_Item_List();
  articleItemList.init();
  const headerComps = new Header_Comps();
  headerComps.init();
  const menuComps = new Menu_Comps();
  menuComps.init();
  //console.log('we are starting here');
  //console.log(process.env.NODE_ENV);
});

//import Router from './util/Router';
//import common from './routes/common';
//import home from './routes/home';
//import pageTemplatePageProgramm from './routes/page-template-page-programm';
//import pageTemplatePageArtikel from './routes/page-template-page-artikel';
//import pageTemplatePageWestream from './routes/page-template-page-westream';

/**
 * Populate Router instance with DOM routes
 * @type {Router} routes - An instance of our router
 */
//const routes = new Router({
  /** All pages */
  //common,
  /** Home page */
  //home,
  /** About Us page, note the change from about-us to aboutUs. */
  //pageTemplatePageProgramm,
  //pageTemplatePageArtikel,
  //pageTemplatePageWestream
//});

/** Load Events */
//jQuery(document).ready(() => routes.loadEvents());
